import PropTypes from "prop-types";
import * as types from "./constants";
import styles from "./index.css";
import classnames from "classnames";

const Banner = ({
  ariaLive,
  className,
  innerContent,
  message,
  outerContent,
  iconClass
}) => (
  <div className={className}>
    <div className={styles.content}>
      <div>
        <div
          className={classnames(styles.container, styles[iconClass])}
          role="alert"
          aria-live={ariaLive}
        >
          <p className={styles.message}>{message}</p>
        </div>
        {innerContent ? innerContent() : null}
      </div>
      {outerContent ? outerContent() : null}
    </div>
  </div>
);

Banner.propTypes = {
  ariaLive: PropTypes.oneOf(["assertive", "polite"]).isRequired,
  className: PropTypes.string,
  innerContent: PropTypes.func,
  message: PropTypes.string.isRequired,
  outerContent: PropTypes.func,
  iconClass: PropTypes.oneOf(Object.values(types))
};

export default Banner;
